"use client";
import { Box, Popper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs, SpaceXs, ColorWhite, ColorGray600, PopoverShadow } from "@nxt-costco-com/forge-design-tokens";
import { ChevronDown } from "@nxt-costco-com/forge-icons";
const StyledChevronDown = styled(ChevronDown)({
  height: "16px",
  padding: 0
});
const LinkButtonContainer = styled(Box)(() => ({
  display: "flex",
  ".MuiButtonBase-root": {
    minWidth: 0,
    marginLeft: SpaceXs,
    padding: SpaceXxs
  },
  ":hover": {
    ".MuiTypography-root": {
      textDecoration: "none"
    }
  }
}));
const Arrow = styled(Box)(() => ({
  position: "absolute",
  width: ".7825rem",
  height: ".7825rem",
  boxSizing: "border-box",
  color: ColorWhite,
  fontSize: ".5rem",
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    border: `1px solid`,
    backgroundColor: ColorWhite,
    transform: "rotate(45deg)"
  }
}));
const StyledPopper = styled(Popper)(
  () => ({
    backgroundColor: ColorWhite,
    borderRadius: 0,
    borderColor: ColorGray600,
    boxShadow: PopoverShadow,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
    zIndex: `100 !important`,
    '&[data-popper-placement*="bottom"] .arrow': {
      top: 0,
      left: 0,
      marginTop: "-1.45em",
      marginLeft: 4,
      marginRight: 4,
      "&::before": {
        borderColor: `${ColorGray600} transparent transparent ${ColorGray600}`,
        transformOrigin: "0 100%"
      }
    },
    '&[data-popper-placement*="top"] .arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-1.45em",
      marginLeft: 4,
      marginRight: 4,
      "&::before": {
        borderColor: `transparent ${ColorGray600} ${ColorGray600} transparent`,
        transformOrigin: "100% 0"
      }
    },
    '&[data-popper-placement*="right"] .arrow': {
      left: 0,
      marginLeft: "-1.45em",
      marginTop: 4,
      marginBottom: 4,
      "&::before": {
        borderColor: `transparent transparent ${ColorGray600} ${ColorGray600}`,
        transformOrigin: "100% 100%"
      }
    },
    '&[data-popper-placement*="left"] .arrow': {
      right: 0,
      marginRight: "-1.45em",
      marginTop: 4,
      marginBottom: 4,
      "&::before": {
        borderColor: `${ColorGray600} ${ColorGray600} transparent transparent`,
        transformOrigin: "0 0"
      }
    }
  })
);
export {
  Arrow,
  LinkButtonContainer,
  StyledChevronDown,
  StyledPopper
};
